import { address_server_short, PUBLIC_ASSETS } from '../../../config';
import { useContext } from 'react';
import { Store } from 'store/context/Store';

const SampleTypeField = ({ forTable, mode, rowsItem }) => {
  const { loadSampleById } = useContext(Store);
  if (forTable) {
    return (
      <div
        style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        onClick={async (e) => {
          e.stopPropagation();
          await loadSampleById(rowsItem.id);
          mode.setVisibleView(true);
          mode.setVisibleAdd(false);
        }}
      >
        <div
          style={{
            borderRadius: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '45px',
            width: '45px',
            fontSize: '25px',
            border: '1px solid var(--border-gray)',
            cursor: 'pointer',
          }}
        >
          <img
            style={{ objectFit: 'contain', width: '80%', height: '80%' }}
            src={address_server_short + PUBLIC_ASSETS + rowsItem?.setting?.sample?.icon}
            alt={'icon'}
          ></img>
        </div>
      </div>
    );
  }
  return null;
};

export default SampleTypeField;
